module.exports = __webpack_public_path__ + "static/vladimir-kurchatkin.da705d14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vladimir-kurchatkin.jpg
// module id = 681
// module chunks = 168707334958949